// extracted by mini-css-extract-plugin
module.exports = {"landing":"ContactPage_landing__ebAHH","contact":"ContactPage_contact__10nd2"};